import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';
import AICampaign from '../components/atoms/CreateCompaign/AICampaign';
import { StyledCreateOfferPage } from '../components/atoms/ProfileInfo/CreateOffer.style';

const CreateOffer = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const { refetch } = useContextHook(AuthContext, v => ({ refetch: v.refetch }));

  const goBackToOffers = () => {
    refetch();
    navigate('/profile', { state: { activeProfileTab: 'offers' } });
  };

  return (
    <StyledCreateOfferPage>
      <AICampaign
        variant="offer"
        data={data}
        setData={setData}
        onCancel={goBackToOffers}
        onComplete={goBackToOffers}
      />
    </StyledCreateOfferPage>
  );
};

export default CreateOffer;
